module.exports = __webpack_public_path__ + "static/media/re.78429f47.png";